import React, { memo, useEffect, useMemo } from "react";
import { useMastersContext } from "../../../../contexts/masters.context";

function CategorySelectFilter({ column }) {
  const { filterValue, setFilter } = column;
  const { categoryState } = useMastersContext();

  const options = useMemo(() => categoryState.data.map((dm) => dm.name), [
    categoryState.data,
  ]);

  return (
    <>
      <select
        className="custom-select custom-select-sm"
        onChange={(e) => setFilter(e.currentTarget.value)}
        defaultValue={filterValue || ""}
      >
        <option value="">All</option>
        {options.map((value, i) => (
          <option value={value} key={i}>
            {value}
          </option>
        ))}
      </select>
    </>
  );
}

export default CategorySelectFilter;
